import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ToastProvider } from '@/components/Toast';

// Pages
import Landing from '@/pages/Landing';
import Onboarding from '@/pages/Onboarding';
import EnrollmentHub from '@/pages/EnrollmentHub';
import TypingSession from '@/pages/TypingSession';
import SessionResult from '@/pages/SessionResult';
import ProfileCreated from '@/pages/ProfileCreated';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Settings from '@/pages/Settings';

/** Título da aba por rota — sempre com a marca ENI HKS. */
const ROUTE_TITLES: Record<string, string> = {
  '/': 'ENI HKS — Human Keystroke Signature',
  '/onboarding': 'Criar conta · ENI HKS',
  '/login': 'Entrar · ENI HKS',
  '/enrollment': 'Cadastro biométrico · ENI HKS',
  '/typing-session': 'Sessão de digitação · ENI HKS',
  '/session-result': 'Resultado · ENI HKS',
  '/profile-created': 'Perfil criado · ENI HKS',
  '/dashboard': 'Painel · ENI HKS',
  '/settings': 'Configurações · ENI HKS',
};

/** Keeps the document title in sync with the current route. */
function DocumentTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = ROUTE_TITLES[pathname] ?? 'ENI HKS — Human Keystroke Signature';
  }, [pathname]);
  return null;
}

/**
 * App — Root component with router and global providers.
 */
export default function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <DocumentTitle />
        <div className="min-h-screen bg-bg-primary text-txt-primary">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Landing />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/login" element={<Login />} />

            {/* Enrollment routes */}
            <Route path="/enrollment" element={<EnrollmentHub />} />
            <Route path="/typing-session" element={<TypingSession />} />
            <Route path="/session-result" element={<SessionResult />} />
            <Route path="/profile-created" element={<ProfileCreated />} />

            {/* Authenticated routes */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/settings" element={<Settings />} />

            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </ToastProvider>
    </BrowserRouter>
  );
}
